/* eslint-disable react/jsx-props-no-spreading */
import { bool, func, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import Image from 'yoda-core-components/lib/components/Image';
import PointCross from 'yoda-core-components/lib/components/PointCross/PointCross';
import * as styles from './ProductImage.css';

const cx = classNames.bind(styles);

const ProductImage = ({
    altImageUrl,
    cardTheme,
    imageSrc,
    imageUrl,
    isAppointmentCards,
    lazyLoadImages,
    onProductClick,
    openInNewTab,
    pointCrossOffsetProps,
    productUrl,
    swatchImageSrc,
    title,
}) => {
    let url = imageSrc || imageUrl || '';
    const [defaultImageUrl, setDefaultImageUrl] = useState(url);
    const [displayImageUrl, setDisplayImageUrl] = useState(url);
    const isCartridgeTheme = cardTheme === 'cartridge';

    const setImageUrl = () => {
        const isS7Image = /scene7.com(.+)/g.test(url);

        if (!imageSrc && isS7Image && cardTheme !== 'gallery') {
            if (imageUrl.indexOf('?') > 0) {
                if (imageUrl.indexOf('hei=') > 0 && imageUrl.indexOf('wid=') > 0) {
                    url = imageUrl
                        .replace(/hei=(.*?)&/, 'hei=170&')
                        .replace(/wid=(.*?)&/, 'wid=170&');
                } else url = `${imageUrl}&hei=170&wid=170&op_sharpen=1`;
            } else url = `${imageUrl}?hei=170&wid=170&op_sharpen=1`;
        }

        setDefaultImageUrl(url);
        setDisplayImageUrl(url);
    };

    useEffect(() => {
        setImageUrl();
    }, [imageSrc]);

    const config = {
        anchor: {
            className: 'h-full w-full',
            href: productUrl,
            onClick: (event) => {
                onProductClick(event, 'image');
            },
            rel: openInNewTab ? 'noopener noreferrer' : null,
            target: openInNewTab ? '_blank' : null,
        },
        image: {
            alt: title,
            className: isCartridgeTheme
                ? `max-h-full w-auto ${styles.cartridge}`
                : `absolute h-full max-w-full w-full ${styles.gallery}`,
            isLazy: !isCartridgeTheme,
            onMouseLeave: () => {
                altImageUrl && setDisplayImageUrl(swatchImageSrc || defaultImageUrl);
            },
            onMouseOver: () => {
                altImageUrl && setDisplayImageUrl(altImageUrl);
            },
            src: displayImageUrl,
        },
        pointCross: {
            ...pointCrossOffsetProps,
            wrapperClass: cx('wrapper', 'h-full relative w-full', {
                'p-0': isCartridgeTheme,
                'pb-0': isAppointmentCards,
            }),
        },
    };

    const renderImage = (
        <div className="h-full relative w-full">
            {lazyLoadImages ? (
                <PointCross {...config.pointCross}>
                    <Image {...config.image} />
                </PointCross>
            ) : (
                <Image {...config.image} />
            )}
        </div>
    );

    return productUrl ? <a {...config.anchor}>{renderImage}</a> : renderImage;
};

/* istanbul ignore next */
ProductImage.defaultProps = {
    altImageUrl: '',
    cardTheme: 'gallery',
    imageSrc: '',
    imageUrl: '',
    isAppointmentCards: false,
    lazyLoadImages: false,
    onProductClick: () => {},
    openInNewTab: false,
    pointCrossOffsetProps: { offset: 500 },
    productUrl: '',
    swatchImageSrc: '',
    title: '',
};

ProductImage.propTypes = {
    altImageUrl: string,
    cardTheme: string,
    imageSrc: string,
    imageUrl: string,
    isAppointmentCards: bool,
    lazyLoadImages: bool,
    onProductClick: func,
    openInNewTab: bool,
    pointCrossOffsetProps: object,
    productUrl: string,
    swatchImageSrc: string,
    title: string,
};

export default ProductImage;
